import { useLingui } from '@lingui/react/macro';
import { type Country } from '../types';

const ICONS_API = 'https://static.elfsight.com/icons/';

export const useGetCountries = () => {
  const { t } = useLingui();
  const usa: Country = {
    countryCode: 'US',
    name: t`United States`,
    phoneCode: '+1',
    iconSrc: `${ICONS_API}app-translator-united-states-multicolor.svg`
  };

  const countries: Country[] = [
    {
      countryCode: 'AF',
      name: t`Afghanistan`,
      phoneCode: '+93',
      iconSrc: `${ICONS_API}app-translator-afghanistan-multicolor.svg`
    },
    {
      countryCode: 'AL',
      name: t`Albania`,
      phoneCode: '+355',
      iconSrc: `${ICONS_API}app-translator-albania-multicolor.svg`
    },
    {
      countryCode: 'AD',
      name: t`Andorra`,
      phoneCode: '+376',
      iconSrc: `${ICONS_API}app-translator-andorra-multicolor.svg`
    },
    {
      countryCode: 'AO',
      name: t`Angola`,
      phoneCode: '+244',
      iconSrc: `${ICONS_API}app-translator-angola-multicolor.svg`
    },
    {
      countryCode: 'AR',
      name: t`Argentina`,
      phoneCode: '+54',
      iconSrc: `${ICONS_API}app-translator-argentina-multicolor.svg`
    },
    {
      countryCode: 'AM',
      name: t`Armenia`,
      phoneCode: '+374',
      iconSrc: `${ICONS_API}app-translator-armenia-multicolor.svg`
    },
    {
      countryCode: 'AC',
      name: t`Ascension Island`,
      phoneCode: '+247',
      iconSrc: `${ICONS_API}app-translator-ascension-island-multicolor.svg`
    },
    {
      countryCode: 'AU',
      name: t`Australia`,
      phoneCode: '+61',
      iconSrc: `${ICONS_API}app-translator-australia-multicolor.svg`
    },
    {
      countryCode: 'AT',
      name: t`Austria`,
      phoneCode: '+43',
      iconSrc: `${ICONS_API}app-translator-austria-multicolor.svg`
    },
    {
      countryCode: 'AZ',
      name: t`Azerbaijan`,
      phoneCode: '+994',
      iconSrc: `${ICONS_API}app-translator-azerbaijan-multicolor.svg`
    },
    {
      countryCode: 'BH',
      name: t`Bahrain`,
      phoneCode: '+973',
      iconSrc: `${ICONS_API}app-translator-bahrain-multicolor.svg`
    },
    {
      countryCode: 'BD',
      name: t`Bangladesh`,
      phoneCode: '+880',
      iconSrc: `${ICONS_API}app-translator-bangladesh-multicolor.svg`
    },
    {
      countryCode: 'BB',
      name: t`Barbados`,
      phoneCode: '+246',
      iconSrc: `${ICONS_API}app-translator-barbados-multicolor.svg`
    },
    {
      countryCode: 'BY',
      name: t`Belarus`,
      phoneCode: '+375',
      iconSrc: `${ICONS_API}app-translator-belarus-multicolor.svg`
    },
    {
      countryCode: 'BE',
      name: t`Belgium`,
      phoneCode: '+32',
      iconSrc: `${ICONS_API}app-translator-belgium-multicolor.svg`
    },
    {
      countryCode: 'BO',
      name: t`Bolivia`,
      phoneCode: '+591',
      iconSrc: `${ICONS_API}app-translator-bolivia-multicolor.svg`
    },
    {
      countryCode: 'BA',
      name: t`Bosnia and Herzegovina`,
      phoneCode: '+387',
      iconSrc: `${ICONS_API}app-translator-bosnia-and-herzegovina-multicolor.svg`
    },
    {
      countryCode: 'BR',
      name: t`Brazil`,
      phoneCode: '+55',
      iconSrc: `${ICONS_API}app-translator-brazil-multicolor.svg`
    },
    {
      countryCode: 'BG',
      name: t`Bulgaria`,
      phoneCode: '+359',
      iconSrc: `${ICONS_API}app-translator-bulgaria-multicolor.svg`
    },
    {
      countryCode: 'CV',
      name: t`Cabo Verde`,
      phoneCode: '+238',
      iconSrc: `${ICONS_API}app-translator-cabo-verde-multicolor.svg`
    },
    {
      countryCode: 'KH',
      name: t`Cambodia`,
      phoneCode: '+855',
      iconSrc: `${ICONS_API}app-translator-cambodia-multicolor.svg`
    },
    {
      countryCode: 'CM',
      name: t`Cameroon`,
      phoneCode: '+237',
      iconSrc: `${ICONS_API}app-translator-cameroon-multicolor.svg`
    },
    {
      countryCode: 'CA',
      name: t`Canada`,
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-canada-multicolor.svg`
    },
    {
      countryCode: 'BQ',
      name: t`Caribbean Netherlands`,
      phoneCode: '+599',
      iconSrc: `${ICONS_API}app-translator-caribbean-netherlands-multicolor.svg`
    },
    {
      countryCode: 'CL',
      name: t`Chile`,
      phoneCode: '+56',
      iconSrc: `${ICONS_API}app-translator-chile-multicolor.svg`
    },
    {
      countryCode: 'CN',
      name: t`China`,
      phoneCode: '+86',
      iconSrc: `${ICONS_API}app-translator-china-multicolor.svg`
    },
    {
      countryCode: 'CO',
      name: t`Colombia`,
      phoneCode: '+57',
      iconSrc: `${ICONS_API}app-translator-colombia-multicolor.svg`
    },
    {
      countryCode: 'CR',
      name: t`Costa Rica`,
      phoneCode: '+506',
      iconSrc: `${ICONS_API}app-translator-costa-rica-multicolor.svg`
    },
    {
      countryCode: 'HR',
      name: t`Croatia`,
      phoneCode: '+385',
      iconSrc: `${ICONS_API}app-translator-croatia-multicolor.svg`
    },
    {
      countryCode: 'CU',
      name: t`Cuba`,
      phoneCode: '+53',
      iconSrc: `${ICONS_API}app-translator-cuba-multicolor.svg`
    },
    {
      countryCode: 'CY',
      name: t`Cyprus`,
      phoneCode: '+357',
      iconSrc: `${ICONS_API}app-translator-cyprus-multicolor.svg`
    },
    {
      countryCode: 'CZ',
      name: t`Czech Republic`,
      phoneCode: '+420',
      iconSrc: `${ICONS_API}app-translator-czech-republic-multicolor.svg`
    },
    {
      countryCode: 'CD',
      name: t`Democratic Republic of the Congo`,
      phoneCode: '+243',
      iconSrc: `${ICONS_API}app-translator-democratic-republic-of-the-congo-multicolor.svg`
    },
    {
      countryCode: 'DK',
      name: t`Denmark`,
      phoneCode: '+45',
      iconSrc: `${ICONS_API}app-translator-denmark-multicolor.svg`
    },
    {
      countryCode: 'DO',
      name: t`Dominican Republic`,
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-dominican-republic-multicolor.svg`
    },
    {
      countryCode: 'EC',
      name: t`Ecuador`,
      phoneCode: '+593',
      iconSrc: `${ICONS_API}app-translator-ecuador-multicolor.svg`
    },
    {
      countryCode: 'EG',
      name: t`Egypt`,
      phoneCode: '+20',
      iconSrc: `${ICONS_API}app-translator-egypt-multicolor.svg`
    },
    {
      countryCode: 'SV',
      name: t`El Salvador`,
      phoneCode: '+503',
      iconSrc: `${ICONS_API}app-translator-el-salvador-multicolor.svg`
    },
    {
      countryCode: 'ER',
      name: t`Eritrea`,
      phoneCode: '+291',
      iconSrc: `${ICONS_API}app-translator-eritrea-multicolor.svg`
    },
    {
      countryCode: 'EE',
      name: t`Estonia`,
      phoneCode: '+372',
      iconSrc: `${ICONS_API}app-translator-estonia-multicolor.svg`
    },
    {
      countryCode: 'SZ',
      name: t`Eswatini`,
      phoneCode: '+268',
      iconSrc: `${ICONS_API}app-translator-eswatini-multicolor.svg`
    },
    {
      countryCode: 'ET',
      name: t`Ethiopia`,
      phoneCode: '+251',
      iconSrc: `${ICONS_API}app-translator-ethiopia-multicolor.svg`
    },
    {
      countryCode: 'FI',
      name: t`Finland`,
      phoneCode: '+358',
      iconSrc: `${ICONS_API}app-translator-finland-multicolor.svg`
    },
    {
      countryCode: 'FR',
      name: t`France`,
      phoneCode: '+33',
      iconSrc: `${ICONS_API}app-translator-france-multicolor.svg`
    },
    {
      countryCode: 'PF',
      name: t`French Polynesia`,
      phoneCode: '+689',
      iconSrc: `${ICONS_API}app-translator-french-polynesia-multicolor.svg`
    },
    {
      countryCode: 'GM',
      name: t`Gambia`,
      phoneCode: '+220',
      iconSrc: `${ICONS_API}app-translator-gambia-multicolor.svg`
    },
    {
      countryCode: 'GE',
      name: t`Georgia`,
      phoneCode: '+995',
      iconSrc: `${ICONS_API}app-translator-georgia-multicolor.svg`
    },
    {
      countryCode: 'DE',
      name: t`Germany`,
      phoneCode: '+49',
      iconSrc: `${ICONS_API}app-translator-germany-multicolor.svg`
    },
    {
      countryCode: 'GH',
      name: t`Ghana`,
      phoneCode: '+233',
      iconSrc: `${ICONS_API}app-translator-ghana-multicolor.svg`
    },
    {
      countryCode: 'GR',
      name: t`Greece`,
      phoneCode: '+30',
      iconSrc: `${ICONS_API}app-translator-greece-multicolor.svg`
    },
    {
      countryCode: 'GT',
      name: t`Guatemala`,
      phoneCode: '+502',
      iconSrc: `${ICONS_API}app-translator-guatemala-multicolor.svg`
    },
    {
      countryCode: 'GN',
      name: t`Guinea`,
      phoneCode: '+224',
      iconSrc: `${ICONS_API}app-translator-guinea-multicolor.svg`
    },
    {
      countryCode: 'GY',
      name: t`Guyana`,
      phoneCode: '+592',
      iconSrc: `${ICONS_API}app-translator-guyana-multicolor.svg`
    },
    {
      countryCode: 'HT',
      name: t`Haiti`,
      phoneCode: '+509',
      iconSrc: `${ICONS_API}app-translator-haiti-multicolor.svg`
    },
    {
      countryCode: 'HN',
      name: t`Honduras`,
      phoneCode: '+504',
      iconSrc: `${ICONS_API}app-translator-honduras-multicolor.svg`
    },
    {
      countryCode: 'HK',
      name: t`Hong Kong`,
      phoneCode: '+852',
      iconSrc: `${ICONS_API}app-translator-hong-kong-multicolor.svg`
    },
    {
      countryCode: 'HU',
      name: t`Hungary`,
      phoneCode: '+36',
      iconSrc: `${ICONS_API}app-translator-hungary-multicolor.svg`
    },
    {
      countryCode: 'IS',
      name: t`Iceland`,
      phoneCode: '+354',
      iconSrc: `${ICONS_API}app-translator-iceland-multicolor.svg`
    },
    {
      countryCode: 'IN',
      name: t`India`,
      phoneCode: '+91',
      iconSrc: `${ICONS_API}app-translator-india-multicolor.svg`
    },
    {
      countryCode: 'ID',
      name: t`Indonesia`,
      phoneCode: '+62',
      iconSrc: `${ICONS_API}app-translator-indonesia-multicolor.svg`
    },
    {
      countryCode: 'IR',
      name: t`Iran`,
      phoneCode: '+98',
      iconSrc: `${ICONS_API}app-translator-iran-multicolor.svg`
    },
    {
      countryCode: 'IQ',
      name: t`Iraq`,
      phoneCode: '+964',
      iconSrc: `${ICONS_API}app-translator-iraq-multicolor.svg`
    },
    {
      countryCode: 'IE',
      name: t`Ireland`,
      phoneCode: '+353',
      iconSrc: `${ICONS_API}app-translator-ireland-multicolor.svg`
    },
    {
      countryCode: 'IL',
      name: t`Israel`,
      phoneCode: '+972',
      iconSrc: `${ICONS_API}app-translator-israel-multicolor.svg`
    },
    {
      countryCode: 'IT',
      name: t`Italy`,
      phoneCode: '+39',
      iconSrc: `${ICONS_API}app-translator-italy-multicolor.svg`
    },
    {
      countryCode: 'JP',
      name: t`Japan`,
      phoneCode: '+81',
      iconSrc: `${ICONS_API}app-translator-japan-multicolor.svg`
    },
    {
      countryCode: 'JO',
      name: t`Jordan`,
      phoneCode: '+962',
      iconSrc: `${ICONS_API}app-translator-jordan-multicolor.svg`
    },
    {
      countryCode: 'KZ',
      name: t`Kazakhstan`,
      phoneCode: '+7',
      iconSrc: `${ICONS_API}app-translator-kazakhstan-multicolor.svg`
    },
    {
      countryCode: 'KE',
      name: t`Kenya`,
      phoneCode: '+254',
      iconSrc: `${ICONS_API}app-translator-kenia-multicolor.svg`
    },
    {
      countryCode: 'KW',
      name: t`Kuwait`,
      phoneCode: '+965',
      iconSrc: `${ICONS_API}app-translator-kuwait-multicolor.svg`
    },
    {
      countryCode: 'KG',
      name: t`Kyrgyzstan`,
      phoneCode: '+996',
      iconSrc: `${ICONS_API}app-translator-kyrgyzstan-multicolor.svg`
    },
    {
      countryCode: 'LA',
      name: t`Laos`,
      phoneCode: '+856',
      iconSrc: `${ICONS_API}app-translator-laos-multicolor.svg`
    },
    {
      countryCode: 'LV',
      name: t`Latvia`,
      phoneCode: '+371',
      iconSrc: `${ICONS_API}app-translator-latvia-multicolor.svg`
    },
    {
      countryCode: 'LB',
      name: t`Lebanon`,
      phoneCode: '+961',
      iconSrc: `${ICONS_API}app-translator-lebanon-multicolor.svg`
    },
    {
      countryCode: 'LS',
      name: t`Lesotho`,
      phoneCode: '+266',
      iconSrc: `${ICONS_API}app-translator-lesotho-multicolor.svg`
    },
    {
      countryCode: 'LI',
      name: t`Liechtenstein`,
      phoneCode: '+423',
      iconSrc: `${ICONS_API}app-translator-liechtenstein-multicolor.svg`
    },
    {
      countryCode: 'LT',
      name: t`Lithuania`,
      phoneCode: '+370',
      iconSrc: `${ICONS_API}app-translator-lithuania-multicolor.svg`
    },
    {
      countryCode: 'LU',
      name: t`Luxembourg`,
      phoneCode: '+352',
      iconSrc: `${ICONS_API}app-translator-luxembourg-multicolor.svg`
    },
    {
      countryCode: 'MG',
      name: t`Madagascar`,
      phoneCode: '+261',
      iconSrc: `${ICONS_API}app-translator-madagascar-multicolor.svg`
    },
    {
      countryCode: 'MW',
      name: t`Malawi`,
      phoneCode: '+265',
      iconSrc: `${ICONS_API}app-translator-malawi-multicolor.svg`
    },
    {
      countryCode: 'MY',
      name: t`Malaysia`,
      phoneCode: '+60',
      iconSrc: `${ICONS_API}app-translator-malaysia-multicolor.svg`
    },
    {
      countryCode: 'MV',
      name: t`Maldives`,
      phoneCode: '+960',
      iconSrc: `${ICONS_API}app-translator-maldives-multicolor.svg`
    },
    {
      countryCode: 'ML',
      name: t`Mali`,
      phoneCode: '+223',
      iconSrc: `${ICONS_API}app-translator-mali-multicolor.svg`
    },
    {
      countryCode: 'MT',
      name: t`Malta`,
      phoneCode: '+356',
      iconSrc: `${ICONS_API}app-translator-malta-multicolor.svg`
    },
    {
      countryCode: 'MR',
      name: t`Mauritania`,
      phoneCode: '+222',
      iconSrc: `${ICONS_API}app-translator-mauritania-multicolor.svg`
    },
    {
      countryCode: 'MX',
      name: t`Mexico`,
      phoneCode: '+52',
      iconSrc: `${ICONS_API}app-translator-mexico-multicolor.svg`
    },
    {
      countryCode: 'MD',
      name: t`Moldova`,
      phoneCode: '+373',
      iconSrc: `${ICONS_API}app-translator-moldova-multicolor.svg`
    },
    {
      countryCode: 'MN',
      name: t`Mongolia`,
      phoneCode: '+976',
      iconSrc: `${ICONS_API}app-translator-mongolia-multicolor.svg`
    },
    {
      name: t`Mozambique`,
      countryCode: 'MZ',
      phoneCode: '+258',
      iconSrc: `${ICONS_API}app-translator-mozambique-multicolor.svg`
    },
    {
      countryCode: 'MM',
      name: t`Myanmar`,
      phoneCode: '+95',
      iconSrc: `${ICONS_API}app-translator-myanmar-multicolor.svg`
    },
    {
      countryCode: 'NA',
      name: t`Namibia`,
      phoneCode: '+264',
      iconSrc: `${ICONS_API}app-translator-namibia-multicolor.svg`
    },
    {
      countryCode: 'NP',
      name: t`Nepal`,
      phoneCode: '+977',
      iconSrc: `${ICONS_API}app-translator-nepal-multicolor.svg`
    },
    {
      countryCode: 'NL',
      name: t`Netherlands`,
      phoneCode: '+31',
      iconSrc: `${ICONS_API}app-translator-netherlands-multicolor.svg`
    },
    {
      countryCode: 'NC',
      name: t`New Caledonia`,
      phoneCode: '+687',
      iconSrc: `${ICONS_API}app-translator-france-multicolor.svg`
    },
    {
      countryCode: 'NZ',
      name: t`New Zealand`,
      phoneCode: '+64',
      iconSrc: `${ICONS_API}app-translator-new-zealand-multicolor.svg`
    },
    {
      countryCode: 'NI',
      name: t`Nicaragua`,
      phoneCode: '+505',
      iconSrc: `${ICONS_API}app-translator-nicaragua-multicolor.svg`
    },
    {
      countryCode: 'NG',
      name: t`Nigeria`,
      phoneCode: '+234',
      iconSrc: `${ICONS_API}app-translator-nigeria-multicolor.svg`
    },
    {
      countryCode: 'MK',
      name: t`North Macedonia`,
      phoneCode: '+389',
      iconSrc: `${ICONS_API}app-translator-north-macedonia-multicolor.svg`
    },
    {
      countryCode: 'NO',
      name: t`Norway`,
      phoneCode: '+47',
      iconSrc: `${ICONS_API}app-translator-norway-multicolor.svg`
    },
    {
      countryCode: 'OM',
      name: t`Oman`,
      phoneCode: '+968',
      iconSrc: `${ICONS_API}app-translator-oman-multicolor.svg`
    },
    {
      countryCode: 'PK',
      name: t`Pakistan`,
      phoneCode: '+92',
      iconSrc: `${ICONS_API}app-translator-pakistan-multicolor.svg`
    },
    {
      countryCode: 'PA',
      name: t`Panama`,
      phoneCode: '+507',
      iconSrc: `${ICONS_API}app-translator-panama-multicolor.svg`
    },
    {
      countryCode: 'PG',
      name: t`Papua New Guinea`,
      phoneCode: '+675',
      iconSrc: `${ICONS_API}app-translator-papua-new-guinea-multicolor.svg`
    },
    {
      countryCode: 'PY',
      name: t`Paraguay`,
      phoneCode: '+595',
      iconSrc: `${ICONS_API}app-translator-paraguay-multicolor.svg`
    },
    {
      countryCode: 'PE',
      name: t`Peru`,
      phoneCode: '+51',
      iconSrc: `${ICONS_API}app-translator-peru-multicolor.svg`
    },
    {
      countryCode: 'PH',
      name: t`Philippines`,
      phoneCode: '+63',
      iconSrc: `${ICONS_API}app-translator-philippines-multicolor.svg`
    },
    {
      countryCode: 'PL',
      name: t`Poland`,
      phoneCode: '+48',
      iconSrc: `${ICONS_API}app-translator-poland-multicolor.svg`
    },
    {
      countryCode: 'PT',
      name: t`Portugal`,
      phoneCode: '+351',
      iconSrc: `${ICONS_API}app-translator-portugal-multicolor.svg`
    },
    {
      countryCode: 'QA',
      name: t`Qatar`,
      phoneCode: '+974',
      iconSrc: `${ICONS_API}app-translator-qatar-multicolor.svg`
    },
    {
      countryCode: 'CG',
      name: t`Republic of the Congo`,
      phoneCode: '+242',
      iconSrc: `${ICONS_API}app-translator-republic-of-the-congo-multicolor.svg`
    },
    {
      countryCode: 'RO',
      name: t`Romania`,
      phoneCode: '+40',
      iconSrc: `${ICONS_API}app-translator-romania-multicolor.svg`
    },
    {
      countryCode: 'RU',
      name: t`Russian Federation`,
      phoneCode: '+7',
      iconSrc: `${ICONS_API}app-translator-russian-federation-multicolor.svg`
    },
    {
      countryCode: 'RW',
      name: t`Rwanda`,
      phoneCode: '+250',
      iconSrc: `${ICONS_API}app-translator-rwanda-multicolor.svg`
    },
    {
      countryCode: 'KN',
      name: t`Saint Kitts and Nevis`,
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-st-kitts-and-nevis-multicolor.svg`
    },
    {
      countryCode: 'LC',
      name: t`Saint Lucia`,
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-saint-lucia-multicolor.svg`
    },
    {
      countryCode: 'MF',
      name: t`Saint Martin`,
      phoneCode: '+590',
      iconSrc: `${ICONS_API}app-translator-st-martin-multicolor.svg`
    },
    {
      countryCode: 'VC',
      name: t`Saint Vincent and Grenadines`,
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-st-vincent-and-grenadines-multicolor.svg`
    },
    {
      countryCode: 'WS',
      name: t`Samoa`,
      phoneCode: '+685',
      iconSrc: `${ICONS_API}app-translator-samoa-multicolor.svg`
    },
    {
      countryCode: 'SA',
      name: t`Saudi Arabia`,
      phoneCode: '+966',
      iconSrc: `${ICONS_API}app-translator-saudi-arabia-multicolor.svg`
    },
    {
      countryCode: 'SN',
      name: t`Senegal`,
      phoneCode: '+221',
      iconSrc: `${ICONS_API}app-translator-senegal-multicolor.svg`
    },
    {
      countryCode: 'RS',
      name: t`Serbia`,
      phoneCode: '+381',
      iconSrc: `${ICONS_API}app-translator-serbia-multicolor.svg`
    },
    {
      countryCode: 'SL',
      name: t`Sierra Leone`,
      phoneCode: '+232',
      iconSrc: `${ICONS_API}app-translator-sierra-leone-multicolor.svg`
    },
    {
      countryCode: 'SG',
      name: t`Singapore`,
      phoneCode: '+65',
      iconSrc: `${ICONS_API}app-translator-singapore-multicolor.svg`
    },
    {
      countryCode: 'SK',
      name: t`Slovakia`,
      phoneCode: '+421',
      iconSrc: `${ICONS_API}app-translator-slovakia-multicolor.svg`
    },
    {
      countryCode: 'SI',
      name: t`Slovenia`,
      phoneCode: '+386',
      iconSrc: `${ICONS_API}app-translator-slovenia-multicolor.svg`
    },
    {
      countryCode: 'SO',
      name: t`Somalia`,
      phoneCode: '+252',
      iconSrc: `${ICONS_API}app-translator-somalia-multicolor.svg`
    },
    {
      countryCode: 'ZA',
      name: t`South Africa`,
      phoneCode: '+27',
      iconSrc: `${ICONS_API}app-translator-south-africa-multicolor.svg`
    },
    {
      countryCode: 'KR',
      name: t`South Korea`,
      phoneCode: '+82',
      iconSrc: `${ICONS_API}app-translator-south-korea-multicolor.svg`
    },
    {
      countryCode: 'ES',
      name: t`Spain`,
      phoneCode: '+34',
      iconSrc: `${ICONS_API}app-translator-spain-multicolor.svg`
    },
    {
      countryCode: 'LK',
      name: t`Sri Lanka`,
      phoneCode: '+94',
      iconSrc: `${ICONS_API}app-translator-sri-lanka-multicolor.svg`
    },
    {
      countryCode: 'SJ',
      name: t`Svalbard and Jan Mayen`,
      phoneCode: '+47',
      iconSrc: `${ICONS_API}app-translator-svalbard-and-jan-mayen-multicolor.svg`
    },
    {
      countryCode: 'SE',
      name: t`Sweden`,
      phoneCode: '+46',
      iconSrc: `${ICONS_API}app-translator-sweden-multicolor.svg`
    },
    {
      countryCode: 'CH',
      name: t`Switzerland`,
      phoneCode: '+41',
      iconSrc: `${ICONS_API}app-translator-switzerland-multicolor.svg`
    },
    {
      countryCode: 'TW',
      name: t`Taiwan`,
      phoneCode: '+886',
      iconSrc: `${ICONS_API}app-translator-taiwan-multicolor.svg`
    },
    {
      countryCode: 'TJ',
      name: t`Tajikistan`,
      phoneCode: '+992',
      iconSrc: `${ICONS_API}app-translator-tajikistan-multicolor.svg`
    },
    {
      countryCode: 'TZ',
      name: t`Tanzania`,
      phoneCode: '+255',
      iconSrc: `${ICONS_API}app-translator-tanzania-multicolor.svg`
    },
    {
      countryCode: 'TH',
      name: t`Thailand`,
      phoneCode: '+66',
      iconSrc: `${ICONS_API}app-translator-thailand-multicolor.svg`
    },
    {
      countryCode: 'TG',
      name: t`Togo`,
      phoneCode: '+228',
      iconSrc: `${ICONS_API}app-translator-togo-multicolor.svg`
    },
    {
      countryCode: 'TT',
      name: t`Trinidad and Tobago`,
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-trinidad-and-tobago-multicolor.svg`
    },
    {
      countryCode: 'TN',
      name: t`Tunisia`,
      phoneCode: '+216',
      iconSrc: `${ICONS_API}app-translator-tunisia-multicolor.svg`
    },
    {
      countryCode: 'TR',
      name: t`Turkey`,
      phoneCode: '+90',
      iconSrc: `${ICONS_API}app-translator-turkey-multicolor.svg`
    },
    {
      countryCode: 'TM',
      name: t`Turkmenistan`,
      phoneCode: '+993',
      iconSrc: `${ICONS_API}app-translator-turkmenistan-multicolor.svg`
    },
    {
      countryCode: 'UG',
      name: t`Uganda`,
      phoneCode: '+256',
      iconSrc: `${ICONS_API}app-translator-uganda-multicolor.svg`
    },
    {
      countryCode: 'UA',
      name: t`Ukraine`,
      phoneCode: '+380',
      iconSrc: `${ICONS_API}app-translator-ukraine-multicolor.svg`
    },
    {
      countryCode: 'AE',
      name: t`United Arab Emirates`,
      phoneCode: '+971',
      iconSrc: `${ICONS_API}app-translator-united-arab-emirates-multicolor.svg`
    },
    {
      countryCode: 'GB',
      name: t`United Kingdom`,
      phoneCode: '+44',
      iconSrc: `${ICONS_API}app-translator-united-kingdom-multicolor.svg`
    },
    usa,
    {
      countryCode: 'UY',
      name: t`Uruguay`,
      phoneCode: '+598',
      iconSrc: `${ICONS_API}app-translator-uruguay-multicolor.svg`
    },
    {
      countryCode: 'UZ',
      name: t`Uzbekistan`,
      phoneCode: '+998',
      iconSrc: `${ICONS_API}app-translator-uzbekistan-multicolor.svg`
    },
    {
      countryCode: 'VE',
      name: t`Venezuela`,
      phoneCode: '+58',
      iconSrc: `${ICONS_API}app-translator-venezuela-multicolor.svg`
    },
    {
      countryCode: 'VN',
      name: t`Vietnam`,
      phoneCode: '+84',
      iconSrc: `${ICONS_API}app-translator-vietnam-multicolor.svg`
    },
    {
      countryCode: 'YE',
      name: t`Yemen`,
      phoneCode: '+967',
      iconSrc: `${ICONS_API}app-translator-yemen-multicolor.svg`
    },
    {
      countryCode: 'ZM',
      name: t`Zambia`,
      phoneCode: '+260',
      iconSrc: `${ICONS_API}app-translator-zambia-multicolor.svg`
    },
    {
      countryCode: 'ZW',
      name: t`Zimbabwe`,
      phoneCode: '+263',
      iconSrc: `${ICONS_API}app-translator-zimbabwe-multicolor.svg`
    }
  ];

  return { usa, countries };
};
